{
  "branding": {
    "frontdesk-attribution": "بدعم من FrontDesk+",
    "practice-logo": "شعار {{name}}"
  },
  "validation": {
    "required": "هذا الحقل مطلوب",
    "invalid-url": "يرجى إدخال عنوان URL صالح",
    "pin-too-short": "يجب أن يحتوي الرمز السري على 4 أحرف على الأقل",
    "pin-default-rejected": "رقم التعريف الشخصي القياسي 0000 غير مسموح به. يرجى تعيين رقم التعريف الشخصي الخاص بك.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "رجوع",
    "next": "التالي",
    "cancel": "إلغاء",
    "confirm": "تأكيد",
    "done": "تم",
    "retry": "إعادة المحاولة",
    "clear": "مسح",
    "close": "إغلاق",
    "verifying": "جاري التحقق...",
    "select": "اختيار",
    "minutes": "دقائق",
    "clock": "",
    "gender": {
      "M": "ذكر",
      "W": "أنثى",
      "D": "آخر",
      "U": "غير معروف"
    },
    "insurance": {
      "GKV": "قانوني",
      "PKV": "خاص",
      "SELFPAY": "دفع ذاتي"
    },
    "scroll-up": "التمرير لأعلى",
    "scroll-down": "التمرير لأسفل"
  },
  "settings": {
    "device-reset": {
      "title": "إعادة ضبط الجهاز",
      "description": "حذف اتصال العيادة وإعدادات الجهاز ورمز PIN من هذا الجهاز.",
      "confirmation": "يجب إعداد هذا الجهاز من جديد. لن تتغير إعدادات SOL أو بيانات المرضى في inSuite.",
      "cancel": "إلغاء",
      "confirm": "إعادة الضبط الآن"
    },
    "title": "الإعدادات",
    "save": "حفظ",
    "save-success": "تم حفظ الإعدادات",
    "save-error": "فشل الحفظ",
    "load-error": "فشل تحميل الإعدادات",
    "pin": {
      "title": "الرمز السري مطلوب",
      "description": "يرجى إدخال الرمز السري للوصول إلى الإعدادات.",
      "error": "رمز سري خاطئ. يرجى المحاولة مرة أخرى.",
      "backspace": "حذف آخر رقم"
    },
    "connection": {
      "title": "الاتصال",
      "description": "إعدادات الاتصال بخادم Doc-Cirrus Bridge",
      "bridge-url": "عنوان URL للجسر",
      "device-name": "اسم الجهاز",
      "device-name-placeholder": "على سبيل المثال الاستقبال، غرفة 1، كشك",
      "device-name-hint": "اسم التعريف في لوحة معلومات Bridge",
      "kim-address": "عنوان KIM (اختياري)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "اختبار",
      "success": "نجح الاتصال",
      "error": "فشل الاتصال",
      "api-unreachable": "لا يمكن الوصول إلى واجهة برمجة تطبيقات DocCirrus",
      "status-title": "حالة الاتصال",
      "status": {
        "api": "واجهة برمجة التطبيقات متصلة",
        "ti": "البنية التحتية لتقنية المعلومات",
        "card-reader": "قارئ البطاقة متاح",
        "medical-card": "بطاقة العيادة (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "رمز Sol (من inSuite)",
      "sol-token-hint": "انسخه من إدارة Bridge في inSuite. مطلوب للاتصال.",
      "sol-token-show": "إظهار الرمز",
      "sol-token-hide": "إخفاء الرمز",
      "bridge-unreachable": "تعذّر الوصول إلى Bridge. يرجى التحقق من العنوان والمنفذ.",
      "diagnostic-id": "معرّف التشخيص: {{id}}",
      "scan-qr": "مسح رمز QR",
      "scan-title": "مسح رمز QR الخاص بـ Bridge",
      "scan-manual": "الإدخال يدويًا"
    },
    "terminal": {
      "title": "قارئ البطاقات",
      "description": "اختيار قارئ البطاقات للبنية التحتية للمعلوماتية الصحية",
      "select": "اختيار الجهاز",
      "select-placeholder": "اختر الجهاز...",
      "loading": "جاري تحميل الأجهزة...",
      "none-available": "لا توجد أجهزة متاحة",
      "none-found": "لم يتم العثور على أجهزة",
      "found": "تم العثور على {{count}} جهاز",
      "connect-hint": "اتصل بخادم الجسر أولاً لتحميل الأجهزة.",
      "found-count": "قارئات البطاقات التي تم العثور عليها: {{count}}",
      "refresh": "إعادة تحميل قارئات البطاقات"
    },
    "practice": {
      "title": "العيادة",
      "description": "معلومات عن عيادتك",
      "name": "اسم العيادة",
      "name-placeholder": "مثال: د. أحمد محمد",
      "welcome-message": "رسالة الترحيب",
      "welcome-placeholder": "مثلاً: مرحباً بكم في عيادتنا",
      "scheduler-available": "تمكين المجدول",
      "scheduler-available-description": "السماح للمرضى بحجز المواعيد من خلال محطة الخدمة الذاتية",
      "prescription-available": "تفعيل خدمة الوصفات الطبية",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "اتركه فارغًا لتظهر التحية بلغة المريض. يظهر نصك الخاص كما هو في كل اللغات."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "تم الحفظ لجميع الأجهزة في {{value}}",
      "never-saved-default": "إعداد افتراضي، لم يتم تغييره بعد."
    },
    "anamnesis": {
      "title": "التاريخ الطبي الرقمي",
      "description": "يعرض رابطًا وQR code لمزود السجل الطبي الخاص بك بعد تسجيل الوصول.",
      "enabled": "إظهار رابط التاريخ الطبي بعد تسجيل الوصول",
      "enabled-description": "يعرض رابطًا وQR code لموفر السجل الطبي الخاص بك بعد إتمام تسجيل الوصول، على سبيل المثال Nelly.",
      "url": "رابط مزود التاريخ الطبي",
      "url-hint": "الرابط ثابت ومتطابق لجميع المرضى.",
      "preview-label": "معاينة شاشة الإكمال",
      "preview-note": "الرابط ثابت ومتطابق لجميع المرضى.",
      "url-first": "أدخل رابطًا صالحًا أولًا لتفعيل هذا الخيار."
    },
    "appearance": {
      "title": "المظهر",
      "description": "تخصيص واجهة المستخدم",
      "language": "اللغة",
      "default-kiosk-language": "لغة المريض الافتراضية",
      "default-kiosk-language-hint": "اللغة التي تبدأ بها جلسات الكشك الجديدة للمرضى.",
      "voice-over-volume": "حجم الصوت",
      "voice-over-hint": "يتحكم في مستوى صوت مساعد التعليق الصوتي لسهولة الوصول إليه.",
      "language-first": "إظهار اختيار اللغة عند بدء الجلسة"
    },
    "security": {
      "title": "الأمان",
      "description": "الرمز السري للوصول إلى الإعدادات",
      "pin": "الرمز السري",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "إدارة الكشك",
    "nav": {
      "general": "عام",
      "flows": "الوظائف",
      "anamnese": "السجل الطبي الرقمي",
      "device": "الجهاز والاتصال"
    },
    "flows": {
      "title": "الوظائف على الجهاز الطرفي"
    },
    "language": {
      "title": "اللغة والقراءة الصوتية",
      "description": "اللغة والقراءة بصوت عالٍ للمرضى على هذا الجهاز."
    }
  },
  "self-service": {
    "title": "الخدمة الذاتية",
    "step-progress": "الخطوة {{current}}/{{total}}",
    "flows": {
      "checkin": "تسجيل الوصول",
      "scheduler": "حجز موعد",
      "prescription": "الوصفات الطبية",
      "locations": "خريطة الموقع",
      "emergency": "طوارئ"
    },
    "audio-guide": {
      "on": "الصوت مفعل",
      "off": "الصوت معطل",
      "replay": "إعادة تشغيل الإرشادات",
      "replay-unavailable": "لا تتوفر إرشادات صوتية لإعادة تشغيلها"
    },
    "language-selector": {
      "title": "اختر اللغة",
      "description": "يرجى اختيار اللغة المفضلة لديك"
    },
    "settings": "الإعدادات",
    "start": {
      "welcome": "مرحباً",
      "subtitle": "يرجى اختيار خيار",
      "check-in-label": "المسار الرئيسي",
      "check-in-cta": "تسجيل الوصول",
      "check-in-description": "هل لديك موعد بالفعل؟ سجل هنا.",
      "check-in-hint": "اجعل بطاقتك جاهزة",
      "scheduler-label": "جديد",
      "scheduler-cta": "حجز موعد",
      "scheduler-description": "احجز موعداً جديداً.",
      "location-plan": "خريطة الموقع",
      "location-plan-description": "اعثر على طريقك إلى غرفة العلاج.",
      "prescription-label": "وصفة طبية",
      "prescription-cta": "الوصفات الطبية والطلب",
      "prescription-description": "عرض الوصفات الطبية أو عبوات النظام.",
      "emergency-cta": "تنبيه طوارئ محلي",
      "emergency-description": "يصدر صوتًا على هذا الجهاز فقط ولا يستدعي المساعدة.",
      "tap-to-start": "انقر للبدء"
    },
    "offline": {
      "banner-title": "تسجيل الوصول غير متاح مؤقتًا",
      "banner-message": "يرجى التحدث مع موظفي الاستقبال للحصول على المساعدة.",
      "emergency-available": "لا يزال التنبيه المحلي متاحًا. فهو لا يستدعي المساعدة.",
      "flow-disabled": "غير متاح مؤقتا"
    },
    "readability": {
      "toggle-label": "وضع القراءة",
      "on": "وضع القراءة",
      "off": "وضع القراءة"
    },
    "reset-overlay": {
      "timeout-title": "انتهت الجلسة",
      "timeout-subtitle": "لقد انتهى وقتك. بياناتك آمنة.",
      "offline-title": "تم فقدان الاتصال",
      "offline-subtitle": "انقطع الاتصال. يرجى التحدث مع موظفي الاستقبال.",
      "interruption-title": "انتهت الجلسة",
      "interruption-subtitle": "لقد تم إنهاء جلستك بأمان.",
      "completion-title": "شكرا لك!",
      "completion-subtitle": "لقد تم إكمال طلبك بنجاح.",
      "reassurance": "لا يتم تخزين بياناتك الشخصية على هذا الجهاز.",
      "auto-dismiss": "سيتم العودة للبدء خلال ثواني {{seconds}}...",
      "dismiss": "اذهب للبدء"
    },
    "timed-terminal": {
      "countdown": "العودة التلقائية في ثواني {{seconds}}",
      "countdown-outcome": "ستعود هذه المحطة تلقائيًا إلى شاشة البداية.",
      "more-time": "المزيد من الوقت",
      "extended": "امتد الوقت"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "هذه الأسئلة غير متاحة بلغتك. يُرجى اختيار إحدى اللغات المتاحة أو التوجه إلى الاستقبال.",
        "alternatives": "مواعيد بديلة",
        "loading": "جارٍ تحميل الأسئلة…",
        "reception-fallback": "يرجى التوجه إلى الاستقبال.",
        "error-title": "تعذر تحميل الأسئلة",
        "language-unavailable-lead": "هذه الأسئلة غير متوفرة بلغتك.",
        "language-unavailable-title": "يرجى اختيار إحدى هذه اللغات",
        "language-unavailable-body": "أو اطلب المساعدة في الاستقبال."
      },
      "start": {
        "title": "حجز موعد",
        "subtitle": "احجز موعدك المفضل في خطوات قليلة",
        "welcome": "مرحباً بك في حجز المواعيد",
        "description": "سنرشدك خلال عملية الحجز",
        "cta": "احجز موعداً الآن"
      },
      "patient-id": {
        "title": "التعريف",
        "subtitle": "يرجى تعريف نفسك",
        "mode-card": "بالبطاقة",
        "mode-search": "بحث",
        "mode-create": "إنشاء جديد",
        "insert-card": "يرجى إدخال بطاقة التأمين الخاصة بك",
        "reading-card": "جاري قراءة البطاقة...",
        "simulate-card": "محاكاة البطاقة",
        "multiple-matches": "تم العثور على عدة مرضى. يتم استخدام بيانات البطاقة.",
        "search-placeholder": "الاسم أو رقم التأمين...",
        "searching": "جاري البحث...",
        "no-results": "لم يتم العثور على نتائج",
        "first-name": "الاسم الأول",
        "last-name": "اسم العائلة",
        "dob": "تاريخ الميلاد",
        "insurance": "التأمين",
        "continue": "متابعة",
        "creating": "خلق المريض...",
        "patient-created": "تم إنشاء المريض بنجاح!",
        "create-error": "لا يمكن إنشاء المريض."
      },
      "appointment-type": {
        "title": "اختر نوع الموعد",
        "subtitle": "يرجى اختيار سبب زيارتك",
        "loading": "جاري تحميل أنواع المواعيد...",
        "no-types": "لا توجد أنواع مواعيد متاحة",
        "error": "تعذر تحميل أنواع المواعيد. يرجى المحاولة مرة أخرى.",
        "no-bookable": "لا يمكن حجز هذه الأنواع من المواعيد عبر الكشك حاليا. يرجى التواصل مع الاستقبال أو الحجز هاتفيا.",
        "disabled-default": "يرجى حجز هذا الموعد مباشرة لدى الاستقبال أو عبر الهاتف.",
        "disabled-footer": "الاستقبال/الهاتف فقط",
        "lead": "ما نوع الموعد الذي تريد حجزه؟",
        "duration": "حوالي {{minutes}} دقيقة",
        "empty-title": "لا يمكن حجز مواعيد هنا حاليًا",
        "none-bookable-title": "لا يمكنك حجز هذه المواعيد هنا",
        "none-bookable-body": "يرجى السؤال في الاستقبال أو الاتصال بنا."
      },
      "types": {
        "general": "استشارة عامة",
        "general-desc": "للشكاوى والأسئلة العامة",
        "checkup": "فحص وقائي",
        "checkup-desc": "فحوصات صحية منتظمة",
        "vaccination": "تطعيم",
        "vaccination-desc": "جدولة موعد تطعيم",
        "followup": "متابعة",
        "followup-desc": "موعد متابعة",
        "prescription": "وصفة طبية",
        "prescription-desc": "استلام وصفة طبية"
      },
      "slot-selection": {
        "title": "اختر موعداً",
        "subtitle": "يرجى اختيار موعد متاح",
        "loading": "جاري تحميل المواعيد المتاحة...",
        "no-slots": "لا توجد مواعيد متاحة",
        "no-appointment-type": "لم يتم اختيار نوع الموعد",
        "error": "تعذر تحميل الفترات المتاحة. يرجى المحاولة مرة أخرى.",
        "quick-select": "المواعيد المتاحة التالية:",
        "select-date": "أو اختر تاريخاً:",
        "times-for": "{{date}}",
        "available": "متاح",
        "unavailable": "لا توجد فترات",
        "slots": "فترات",
        "select-time-hint": "اضغط على وقت لحجز موعدك",
        "week-short": "أسبوع",
        "weekday-mon": "الإثنين",
        "weekday-tue": "الثلاثاء",
        "weekday-wed": "الأربعاء",
        "weekday-thu": "الخميس",
        "weekday-fri": "الجمعة",
        "weekday-sat": "السبت",
        "weekday-sun": "الأحد",
        "period-morning": "صباحاً",
        "period-midday": "ظهراً",
        "period-afternoon": "بعد الظهر",
        "period-evening": "مساءً",
        "period-morning-short": "ص",
        "period-midday-short": "ظ",
        "period-afternoon-short": "ب.ظ",
        "period-evening-short": "م",
        "period-dots-legend": "توفر الوقت",
        "filter-hint": "تصفية حسب الأوقات المفضلة:",
        "or-choose-below": "أو اختر أدناه",
        "no-slots-period": "لا فتحات",
        "show-all": "إظهار الكل",
        "free": "مجانا",
        "your-selection": "اختيارك",
        "oclock": "الساعة",
        "choose-slot": "اختر فتحة",
        "choose-day": "اختر اليوم",
        "choose-day-first": "يرجى اختيار يوم أولًا",
        "times-heading": "الأوقات المتاحة يوم {{date}}",
        "time-value": "{{time}}",
        "empty-title": "لا توجد مواعيد متاحة في {{month}}",
        "empty-body": "اطلع على الشهر التالي أو اسأل في الاستقبال – يسعدنا مساعدتك.",
        "next-month": "الشهر التالي",
        "previous-month": "الشهر السابق"
      },
      "confirmation": {
        "patient-responses": "إجاباتك",
        "review-loading": "جارٍ التحقق من الملخص…",
        "review-unavailable": "الملخص غير متاح. يرجى المحاولة مرة أخرى أو السؤال في الاستقبال.",
        "check-booking": "التحقق من حالة الحجز",
        "title": "تأكيد الموعد",
        "subtitle": "يرجى مراجعة حجزك",
        "patient": "المريض",
        "datetime": "التاريخ والوقت",
        "booking": "جاري الحجز...",
        "confirm": "حجز الموعد",
        "heading": "هل يبدو هذا صحيحا؟",
        "lead": "يرجى تأكيد موعدك.",
        "appointment": "موعد",
        "insured-via": "المؤمن من خلال",
        "description-label": "ملاحظات للعيادة (اختياري)",
        "description-hint": "أخبرنا إذا كان هناك شيء يجب مراعاته عند حجز الموعد أو عند تسجيل الوصول.",
        "description-placeholder": "مثلاً: محدودية الحركة، شخص مرافق، ملاحظات مهمة",
        "description-too-long": "يرجى اختصار الملاحظة إلى 500 حرف أو أقل.",
        "summary": "ملخص",
        "change": "التغيير",
        "book-binding": "حجز موعد",
        "cancel": "إلغاء",
        "type-label": "نوع الموعد",
        "datetime-value": "{{date}} الساعة {{time}}",
        "name-label": "الاسم",
        "insurance-label": "التأمين",
        "insurance-GKV": "تأمين صحي قانوني",
        "insurance-PKV": "تأمين صحي خاص",
        "insurance-SELFPAY": "دفع ذاتي",
        "change-time": "تغيير الموعد",
        "description-free-text": "ملاحظات أخرى (اختياري)",
        "note-wheelchair": "أستخدم كرسيًا متحركًا",
        "note-companion": "سآتي مع مرافق",
        "note-interpreter": "أحتاج إلى مترجم"
      },
      "done": {
        "title": "تم حجز الموعد!",
        "label": "حجزت",
        "subtitle": "تم حجز موعدك بنجاح.",
        "date": "التاريخ",
        "time": "الوقت",
        "booking-id": "رقم الحجز",
        "qr-hint": "إضافة إلى التقويم",
        "qr-description": "امسح رمز QR هذا بكاميرا هاتفك الذكي لإضافة الموعد إلى تطبيق التقويم",
        "auto-redirect": "سيتم إعادة توجيهك إلى الصفحة الرئيسية قريباً...",
        "auto-redirect-countdown": "العودة إلى البداية خلال {{seconds}} ثانية...",
        "back-to-start": "العودة إلى البداية",
        "print-button": "طباعة ورقة الموعد",
        "print-preparing": "جارٍ تحضير عرض الطباعة…",
        "print-error": "تعذر فتح ورقة الموعد. يرجى المحاولة مرة أخرى أو طلب المساعدة من مكتب الاستقبال.",
        "print-returned": "تم إغلاق عرض الطباعة في النظام. يمكنك طلب نسخة أخرى عند الحاجة.",
        "print-title": "موعدك",
        "print-location": "الموقع",
        "print-map-hint": "فتح الموقع على هاتفك",
        "print-error-v2": "تعذر فتح ورقة الموعد. يرجى المحاولة مرة أخرى أو السؤال في الاستقبال."
      },
      "error": {
        "assistance-info": "لم نتمكن من تأكيد حجزك. ربما تم حجز موعدك بالفعل. يرجى السؤال في الاستقبال.",
        "pending-title": "الحجز غير مؤكد",
        "pending-info": "لم نتمكن من تأكيد حجزك. ربما تم حجز موعدك بالفعل. يرجى التحقق مرة أخرى أو السؤال في الاستقبال.",
        "title": "فشل الحجز",
        "subtitle": "تعذر حجز الموعد.",
        "info": "يرجى المحاولة مرة أخرى أو السؤال في الاستقبال."
      },
      "phase": {
        "identify": "تسجيل الدخول",
        "choose": "اختيار الموعد",
        "confirm": "تأكيد"
      }
    },
    "prescription": {
      "start": {
        "title": "الوصفات الطبية والطلب",
        "subtitle": "أدخل بطاقة التأمين الخاصة بك لعرض الوصفات الطبية أو عبوات الطلب.",
        "button": "أدخل البطاقة"
      },
      "card-check": {
        "loading": "جارٍ تحميل قارئ البطاقة...",
        "no-terminal": "لم يتم تكوين قارئ البطاقة",
        "no-terminal-hint": "يرجى الاتصال بالموظفين للحصول على المساعدة.",
        "insert-card": "الرجاء إدخال بطاقتك",
        "insert-card-hint": "أدخل بطاقة التأمين الخاصة بك في قارئ البطاقة.",
        "card-detected": "تم اكتشاف البطاقة",
        "reading": "بطاقة القراءة...",
        "reading-hint": "من فضلك انتظر لحظة.",
        "error": "خطأ في قراءة البطاقة",
        "retry": "حاول مرة أخرى",
        "manual-lookup": "استمر بدون بطاقة",
        "load-error": "تعذر تحميل قارئ البطاقة",
        "read-error": "لا يمكن قراءة البطاقة"
      },
      "patient-selection": {
        "title": "اختر المريض",
        "subtitle": "تم العثور على العديد من المرضى. الرجاء تحديد اسمك.",
        "try-again": "حاول مرة أخرى",
        "try-again-hint": "أدخل البطاقة مرة أخرى"
      },
      "list": {
        "title": "الوصفات الطبية الخاصة بك",
        "for-patient": "وصفات طبية لـ{{name}}",
        "loading": "جارٍ تحميل الوصفات الطبية...",
        "error-title": "خطأ في التحميل",
        "fetch-error": "لا يمكن تحميل الوصفات الطبية",
        "back-home": "العودة إلى البداية",
        "done": "تم"
      },
      "detail": {
        "prescription-info": "معلومات الوصفة الطبية",
        "date": "التاريخ",
        "prescriber": "الواصف",
        "comment": "ملاحظة",
        "medications": "الأدوية",
        "form": "النموذج",
        "pack-size": "حجم العبوة",
        "manufacturer": "الشركة المصنعة",
        "loading": "جارٍ تحميل الوصفة الطبية...",
        "fetch-error": "لا يمكن تحميل تفاصيل الوصفة الطبية",
        "back-to-list": "العودة إلى القائمة",
        "print": "طباعة"
      },
      "types": {
        "public": "وصفة طبية عامة",
        "private": "وصفة طبية خاصة",
        "long-term": "وصفة طبية طويلة الأمد",
        "btm": "وصفة مخدرة",
        "g": "وصفة طبية خضراء",
        "t": "وصفة طبية"
      },
      "no-patient": {
        "title": "لم يتم العثور على المريض",
        "subtitle": "لسوء الحظ، لم يتم العثور على مريض لهذه البطاقة. يرجى الاتصال بالموظفين للحصول على المساعدة.",
        "try-again": "حاول مرة أخرى",
        "back-home": "العودة إلى البداية",
        "title-v2": "لم يتم العثور على بيانات مطابقة",
        "subtitle-v2": "لم نتمكن من إيجادك. يرجى المحاولة مرة أخرى أو السؤال في الاستقبال."
      },
      "done": {
        "title": "شكرا لك",
        "subtitle": "يمكنك الجلوس الآن. إذا كانت لديك أسئلة، يرجى الاتصال بالموظفين.",
        "no-prescriptions-title": "لا توجد وصفات طبية في الملف",
        "no-prescriptions-subtitle": "لم نتمكن من العثور على أي وصفات طبية نشطة بالنسبة لك. إذا كنت تتوقع ذلك، يرجى الاتصال بموظفي الاستقبال.",
        "error-title": "حدث خطأ",
        "error-subtitle": "يرجى الاتصال بالموظفين لمزيد من المساعدة.",
        "auto-redirect": "إعادة التوجيه التلقائي خلال ثواني {{seconds}}",
        "finish": "العودة إلى البداية"
      },
      "hub": {
        "title": "الوصفات الطبية الخاصة بك",
        "for-patient": "وصفات طبية لـ{{name}}",
        "loading": "جارٍ تحميل الوصفات الطبية...",
        "error-title": "خطأ في التحميل",
        "fetch-error": "لا يمكن تحميل الوصفات الطبية",
        "back-home": "العودة إلى البداية",
        "done": "تم",
        "order-button": "طلب وصفة طبية",
        "existing-prescriptions": "الوصفات الطبية الحالية الخاصة بك",
        "no-prescriptions": "لم يتم العثور على وصفات طبية نشطة."
      },
      "patient-lookup": {
        "title": "البحث عن المريض",
        "subtitle": "أدخل اسمك وتاريخ ميلادك.",
        "last-name": "الاسم الأخير",
        "first-name": "الاسم الأول",
        "date-of-birth": "تاريخ الميلاد",
        "lastname": "الاسم الأخير",
        "lastname-placeholder": "اسمك الأخير",
        "firstname": "الاسم الأول",
        "firstname-placeholder": "اسمك الأول",
        "dob": "تاريخ الميلاد",
        "search": "بحث",
        "searching": "جارٍ البحث...",
        "search-error": "خطأ في البحث: {{message}}",
        "no-match": "لم يتم العثور على مريض. يرجى التحقق من المعلومات الخاصة بك.",
        "error": "خطأ في البحث. يرجى المحاولة مرة أخرى.",
        "found": "تم العثور على المريض",
        "confirm": "تأكيد",
        "ambiguous": "مباريات متعددة",
        "ambiguous-hint-firstname": "الرجاء أيضًا إدخال اسمك الأول لتحسين البحث.",
        "ambiguous-hint-additional": "يرجى التحقق من المعلومات الخاصة بك أو الاتصال بالموظفين.",
        "not-found": "لم يتم العثور على المريض",
        "not-found-hint": "ولم يتم العثور على مريض بهذه التفاصيل.",
        "not-found-action": "حاول مرة أخرى"
      },
      "manual-identification": {
        "unverified": "لم يتم تأكيد هويتك باستخدام بطاقة التأمين الصحي. ستتحقق العيادة من بياناتك وطلبك قبل معالجته."
      },
      "medication-selection": {
        "title": "طلب وصفة طبية",
        "subtitle": "تراجع العيادة طلبك. بعد الموافقة، سيكون eRx جاهزاً في تطبيق e-prescription.",
        "back": "العودة",
        "submit": "مواصلة المراجعة",
        "reason-title": "لماذا تحتاج إلى وصفة طبية؟",
        "reason-hint": "يساعد العيادة على تقييم طلبك.",
        "reason-validation": "الرجاء اختيار السبب.",
        "reason-schmerzen": "ألم",
        "reason-entzuendung": "التهاب",
        "reason-nachsorge": "بعد الجراحة / الإجراء",
        "reason-allergie": "الحساسية / رد الفعل",
        "reason-chronisch": "حالة مزمنة",
        "reason-anderes": "شيء آخر",
        "medications-title": "أي أدوية؟",
        "request-hint": "قم بوصف ما تحتاجه، أو قم بتسمية الوصفة الطبية السابقة التي تريد تجديدها.",
        "request-placeholder": "على سبيل المثال إيبوبروفين 600 ملغ، نفس المرة السابقة",
        "request-validation": "يرجى وصف الدواء الذي تحتاجه.",
        "history-title": "الوصفات الطبية السابقة",
        "history-hint": "أضف إدخالاً لملء طلبك مسبقًا.",
        "history-loading": "جاري تحميل الوصفات الطبية السابقة...",
        "history-error": "لا يمكن تحميل الوصفات الطبية السابقة.",
        "history-add": "أضف",
        "history-added": "تمت الإضافة",
        "history-date": "الأخير: {{date}}",
        "history-request-line": "التجديد: {{medicationName}}",
        "urgency-title": "ما مدى إلحاح الأمر؟",
        "urgency-hint": "يساعد العيادة على تحديد الأولوية.",
        "urgency-soon": "عاجل",
        "urgency-soon-meta": "في أقرب وقت ممكن",
        "urgency-tomorrow": "قريبا",
        "urgency-tomorrow-meta": "في الأيام القليلة المقبلة",
        "urgency-week": "هذا الاسبوع",
        "urgency-week-meta": "لا يوجد ضغط الوقت",
        "lead": "تراجع العيادة طلبك. بعد الموافقة ستجد وصفتك الإلكترونية في تطبيق الوصفات الإلكترونية أو على بطاقة التأمين الصحي.",
        "history-hint-v2": "اضغط على وصفة سابقة لإضافتها.",
        "history-retry": "إعادة التحميل"
      },
      "request-review": {
        "title": "مراجعة الطلب",
        "subtitle": "يرجى مراجعة طلب الوصفة الطبية الخاصة بك.",
        "request-label": "الدواء المطلوب",
        "selected-medications": "أدوية مختارة",
        "free-text-medications": "أدوية إضافية",
        "freetext-label": "أخرى",
        "quarterly-warning": "لم تتم قراءة بطاقة التأمين الخاصة بك خلال هذا الربع. قد تتواصل العيادة معك.",
        "egk-warning": "لم تتم قراءة بطاقة التأمين الخاصة بك خلال هذا الربع. قد تتواصل العيادة معك.",
        "submit": "إرسال",
        "submitting": "جارٍ الإرسال...",
        "submit-error": "لا يمكن تقديم الطلب. يرجى المحاولة مرة أخرى.",
        "back": "العودة",
        "reason-label": "السبب",
        "urgency-label": "إلحاح",
        "completion-email-choice": "أرغب في تلقي بريد إلكتروني عندما تعالج العيادة طلبي.",
        "completion-email-label": "عنوان البريد الإلكتروني",
        "completion-email-placeholder": "name@example.com",
        "completion-email-hint": "لهذه الرسالة لمرة واحدة فقط. لن يُحفظ العنوان ضمن البيانات الأساسية.",
        "completion-email-invalid": "يرجى إدخال عنوان بريد إلكتروني صالح.",
        "egk-proof-required": "طلبات الوصفات متاحة فقط بعد قراءة بطاقة التأمين بنجاح. يرجى التواصل مع الموظفين.",
        "title-v2": "مراجعة الطلب",
        "completion-email-hint-v2": "يُستخدم العنوان لهذه الرسالة فقط."
      },
      "confirmation": {
        "title": "تم إرسال الطلب",
        "subtitle": "لقد تم إرسال طلب الوصفة الطبية الخاص بك بنجاح.",
        "success-title": "تم إرسال الطلب",
        "success-subtitle": "لقد تم إرسال طلب الوصفة الطبية الخاص بك بنجاح.",
        "estimated-time": "ستكون الوصفة الطبية الخاصة بك جاهزة خلال حوالي {{time}}.",
        "info": "يمكنك الحصول على الوصفة الطبية الخاصة بك من الصيدلية باستخدام بطاقة التأمين الخاصة بك أو تطبيق eRezept.",
        "auto-redirect": "إعادة التوجيه التلقائي خلال ثواني {{seconds}}",
        "back-to-start": "العودة إلى البداية",
        "handling-label": "Handled by the practice",
        "next-steps": "تراجع العيادة طلبك. بعد الموافقة يمكنك صرف وصفتك الإلكترونية في الصيدلية ببطاقة التأمين الصحي أو بتطبيق الوصفات الإلكترونية."
      },
      "phase": {
        "identify": "تسجيل الدخول",
        "request": "الطلب",
        "review": "المراجعة"
      }
    },
    "check-in": {
      "flow-label": "تسجيل الوصول",
      "has-appointment": {
        "eyebrow": "موعد",
        "title": "هل لديك موعد؟",
        "subtitle": "يرجى اختيار خيار",
        "yes-label": "نعم",
        "yes": "نعم، لدي موعد",
        "yes-description": "أريد تسجيل الوصول لموعدي.",
        "yes-hint": "أسرع طريق",
        "unsure-label": "ربما",
        "unsure": "لست متأكداً",
        "unsure-description": "سنتحقق من ذلك لك.",
        "unsure-hint": "سوف نبحث عنك",
        "no-label": "لا",
        "no": "لا، بدون موعد",
        "no-description": "ليس لدي موعد.",
        "no-hint": "دخول"
      },
      "card-check": {
        "eyebrow": "بطاقة التأمين",
        "title": "قراءة بطاقة التأمين",
        "subtitle": "يرجى إدخال بطاقة التأمين في القارئ",
        "insert-title": "أدخل بطاقة التأمين في قارئ البطاقات.",
        "insert-detail": "نقرأ التفاصيل الخاصة بك تلقائيًا، ولا تحتاج إلى القيام بأي شيء آخر.",
        "other-ways": "طرق أخرى",
        "no-card-hint": "إذا لم تكن بطاقتك معك الآن.",
        "pkv-hint": "استخدم QR code مع تطبيق التأمين الخاص بك.",
        "loading": "جاري تحميل الإعدادات...",
        "no-terminal": "لم يتم تكوين قارئ البطاقات. يرجى الاتصال بالموظفين.",
        "checking": "جاري التحقق من البطاقات...",
        "insert-prompt": "يرجى إدخال البطاقة...",
        "card-detected": "تم اكتشاف البطاقة! جاهز للقراءة.",
        "read-card": "قراءة البطاقة",
        "simulate-insert": "محاكاة البطاقة",
        "reading": "جاري قراءة البطاقة...",
        "error": "تعذرت قراءة البطاقة. يرجى المحاولة مرة أخرى.",
        "read-error": "فشلت قراءة بيانات البطاقة. يرجى المحاولة مرة أخرى.",
        "settings-error": "تعذر تحميل الإعدادات. يرجى المحاولة مرة أخرى.",
        "no-card-prompt": "ليس لديك بطاقة؟",
        "no-card-action": "بحث يدوي",
        "connection-warning": "مشاكل الاتصال مع قارئ البطاقة. من فضلك انتظر...",
        "pkv-prompt": "هل لديك تأمين خاص؟ Online Check-in",
        "pkv-instruction": "قم بمسح QR code ضوئيًا باستخدام تطبيق التأمين الصحي الخاص بك لنقل بياناتك رقميًا.",
        "pkv-continue": "الاستمرار في التسجيل اليدوي",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "يرجى المحاولة مرة أخرى أو التسجيل بدون بطاقة. يسعد موظفو الاستقبال بمساعدتك.",
        "title-pkv": "التسجيل عبر التطبيق",
        "title-reading": "تتم قراءة بطاقتك …",
        "title-unreadable": "تعذرت قراءة البطاقة",
        "title-no-terminal": "التسجيل بدون بطاقة",
        "no-terminal-body": "قارئ البطاقات غير متاح حاليًا. يرجى التسجيل بدون بطاقة أو التوجه إلى الاستقبال.",
        "reading-detail": "يرجى ترك البطاقة في القارئ. لن يستغرق ذلك سوى لحظة.",
        "other-ways-title": "خيارات أخرى",
        "no-card-title": "التسجيل بدون بطاقة",
        "pkv-prompt-title": "لديك تأمين خاص؟",
        "pkv-prompt-hint": "التسجيل عبر تطبيق تأمينك الصحي الخاص",
        "pkv-close": "التسجيل بالبطاقة بدلًا من ذلك",
        "pkv-instruction-app": "افتح تطبيق تأمينك الصحي الخاص وامسح هذا الرمز. تصلنا بياناتك مباشرة."
      },
      "patient-selection": {
        "title": "اختر المريض",
        "subtitle": "تم العثور على عدة مرضى. يرجى اختيار نفسك.",
        "firstname-label": "اسمك الأول",
        "firstname-placeholder": "أدخل الاسم الأول...",
        "confirm-button": "تأكيد",
        "no-match": "لم يتم العثور على مريض مطابق. يرجى الذهاب إلى مكتب الاستقبال للحصول على المساعدة.",
        "still-ambiguous": "تبقى عدة مباريات. يرجى الذهاب إلى مكتب الاستقبال للحصول على المساعدة.",
        "select-error": "فشل في التعرف على المريض. يرجى المحاولة مرة أخرى.",
        "staff-assist": "اذهب إلى الاستقبال",
        "title-v2": "سؤال قصير",
        "subtitle-v2": "للتأكد، يرجى إدخال اسمك الأول.",
        "no-match-v2": "لم نعثر عليك بهذا الاسم. يرجى التحقق من الإملاء أو التوجه إلى الاستقبال.",
        "still-ambiguous-v2": "لم نتمكن بعد من التعرف عليك بوضوح. يرجى التوجه إلى الاستقبال.",
        "select-error-v2": "للأسف لم ينجح ذلك. يرجى المحاولة مرة أخرى."
      },
      "card-checkin": {
        "title": "تأكيد تسجيل الوصول",
        "subtitle": "تم قراءة بياناتك بنجاح.",
        "confirm": "تأكيد تسجيل الوصول"
      },
      "register-from-card": {
        "title": "تسجيل جديد",
        "subtitle": "أنت لست في نظامنا بعد. هل تريد التسجيل؟",
        "card-data": "بيانات البطاقة",
        "create": "تسجيل",
        "create-error": "فشل التسجيل. يرجى المحاولة مرة أخرى أو اطلب المساعدة من الموظفين.",
        "staff-assist": "اتصل بالموظفين",
        "no-card-data-title": "لا توجد بيانات البطاقة",
        "no-card-data": "غير قادر على قراءة البيانات من بطاقتك.",
        "insurance-verified": "تم التحقق من التأمين: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "بياناتك من البطاقة",
        "subtitle-v2": "يرجى التحقق من بياناتك. إذا كان هناك خطأ، فاضغط على «تغيير».",
        "create-v2": "تأكيد البيانات",
        "create-error-v2": "للأسف لم ينجح التسجيل. يرجى المحاولة مرة أخرى أو التوجه إلى الاستقبال.",
        "insurer-missing-v2": "لا تحتوي بطاقتك على بيانات التأمين الصحي. يرجى التوجه إلى الاستقبال.",
        "edit": "تغيير",
        "name": "الاسم",
        "insurer": "التأمين الصحي"
      },
      "patient-lookup": {
        "title": "بحث عن مريض",
        "subtitle": "يرجى إدخال اسمك أو رقم التأمين.",
        "lastname": "الاسم الأخير",
        "lastname-placeholder": "اسمك الأخير",
        "dob": "تاريخ الميلاد",
        "firstname": "الاسم الأول",
        "firstname-placeholder": "اسمك الأول",
        "search": "بحث",
        "searching": "جارٍ البحث...",
        "search-placeholder": "الاسم أو رقم التأمين...",
        "results-placeholder": "ستظهر نتائج البحث هنا",
        "found": "تم العثور على المريض!",
        "confirm-identity": "يرجى التأكد من أنك المريض الموضح.",
        "confirm-button": "هذا أنا",
        "ambiguous-firstname": "تم العثور على العديد من المرضى. الرجاء إدخال اسمك الأول.",
        "ambiguous-additional": "تم العثور على العديد من المرضى. يرجى الاتصال بالموظفين.",
        "disambiguation-hint": "وهذا يساعدنا على التعرف عليك بوضوح.",
        "not-found": "ولم يتم العثور على مريض بهذه التفاصيل.",
        "error": "خطأ في البحث: {{message}}",
        "staff-assist": "اتصل بالموظفين",
        "not-found-prompt": "لم يتم العثور عليه؟",
        "register-new": "تسجيل جديد",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "التسجيل بدون بطاقة",
        "subtitle-firstname": "يرجى إدخال اسمك الأول أيضًا.",
        "ambiguous-firstname-v2": "يوجد عدة أشخاص بهذا الاسم. يرجى إدخال اسمك الأول أيضًا.",
        "search-again": "البحث مرة أخرى",
        "found-v2": "وجدناك",
        "found-confirm": "يرجى التأكيد بالضغط على «هذا أنا».",
        "not-found-title": "لم نعثر عليك",
        "not-found-check": "يرجى التحقق من الإملاء وتاريخ الميلاد. يسعد موظفو الاستقبال بمساعدتك.",
        "not-found-reception": "يرجى التحقق من الإملاء وتاريخ الميلاد أو التوجه إلى الاستقبال.",
        "ambiguous-additional-v2": "لم نتمكن من التعرف عليك بوضوح. يرجى التوجه إلى الاستقبال.",
        "error-v2": "لم ينجح البحث حاليًا. يرجى المحاولة مرة أخرى."
      },
      "checking-in": {
        "title": "لحظة واحدة – نحن نقوم بتسجيل وصولك.",
        "subtitle": "نحن نضيفك إلى قائمة انتظار العلاج ونقوم بإبلاغ الفريق.",
        "step-insurance": "فحص التأمين",
        "step-appointment": "تم تأكيد الموعد",
        "step-waitlist": "إضافة إلى قائمة الانتظار",
        "error": "فشل تسجيل الوصول. يرجى المحاولة مرة أخرى.",
        "continue": "استمر على أي حال",
        "title-v2": "لحظة من فضلك",
        "loading": "جارٍ تسجيلك …",
        "subtitle-v2": "نضيفك إلى قائمة الانتظار ونبلغ الفريق.",
        "error-title": "للأسف لم ينجح ذلك",
        "error-v2": "تعذر إكمال تسجيلك.",
        "error-body": "يرجى المحاولة مرة أخرى. إذا لم ينجح ذلك مجددًا، فسيساعدك الاستقبال."
      },
      "appointment-selection": {
        "title": "حدد الموعد",
        "subtitle": "لديك عدة مواعيد اليوم. الرجاء اختيار واحد.",
        "checking-in": "تسجيل الوصول...",
        "time": "{{time}}",
        "error-v2": "لم ينجح التسجيل لهذا الموعد. يرجى المحاولة مرة أخرى أو التوجه إلى الاستقبال."
      },
      "no-appointment": {
        "title": "لم يتم العثور على موعد",
        "subtitle": "لم نتمكن من العثور على موعد لك اليوم. يرجى حجز موعد منتظم.",
        "book-appointment": "حجز موعد",
        "book-appointment-description": "حجز موعد جديد من خلال المجدول العادي.",
        "staff-assist": "اتصل بالموظفين",
        "staff-assist-description": "انا بحاجة للمساعدة.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "لم نجد لك موعدًا اليوم.",
        "book-v2": "حجز موعد جديد",
        "book-v2-description": "اختر الآن موعدًا متاحًا.",
        "have-appointment": "لدي موعد",
        "have-appointment-description": "يسعد موظفو الاستقبال بمساعدتك.",
        "unavailable-title": "يرجى حجز المواعيد في الاستقبال",
        "subtitle-unavailable": "لم نجد لك موعدًا اليوم. يرجى التوجه إلى الاستقبال."
      },
      "staff-assist": {
        "title": "تم إخطار الموظفين",
        "subtitle": "سيقوم أحد الموظفين بمساعدتك قريبًا.",
        "message": "من فضلك انتظر هنا. سيكون أحد الموظفين معك قريبًا.",
        "start-over": "العودة للبدء",
        "auto-redirect": "سيتم العودة للبدء خلال ثواني {{seconds}}..."
      },
      "eeb-prompt": {
        "title": "التحقق من التأمين",
        "title-failed": "فشل التحقق",
        "subtitle": "كيف تريد التحقق من تأمينك؟",
        "subtitle-failed": "امسح رمز QR بتطبيق شركة التأمين لطلب التحقق.",
        "verify-card": "التحقق إلكترونياً",
        "verify-card-description": "إرسال طلب إلى شركة التأمين الخاصة بك.",
        "select-insurer": "اختر شركة التأمين",
        "select-insurer-description": "الاختيار اليدوي لشركة التأمين الخاصة بك.",
        "skip": "تخطي",
        "eyebrow-chip": "بديل",
        "eyebrow": "تسجيل الوصول · إثبات التأمين (eEB)",
        "recommended": "موصى به",
        "qr-title": "قم بالمسح باستخدام تطبيق التأمين الخاص بك",
        "qr-description": "افتح تطبيق التأمين الصحي الخاص بك وامسح الرمز ضوئيًا - يتم إرسال eEB إلينا مباشرة.",
        "qr-address-label": "أرسل إلى",
        "title-app": "الإثبات عبر التطبيق",
        "subtitle-app": "يمكن لتأمينك الصحي أيضًا إرسال الإثبات إلينا مباشرة. عند الانتهاء، اضغط على «التالي»."
      },
      "quarterly-check": {
        "title": "التحقق من التأمين",
        "checking": "نحن نتحقق من التحقق الحالي من تأمينك...",
        "error": "تعذر إجراء الفحص.",
        "title-v2": "تأمينك",
        "checking-v2": "نتحقق من تأمينك – لحظة من فضلك.",
        "error-body": "اكتمل تسجيلك. سيوضح الاستقبال أمر تأمينك معك."
      },
      "insurer-prefilled": {
        "title": "تأمينك الصحي",
        "subtitle": "يرجى تأكيد تأمينك لهذا الربع.",
        "your-insurance": "تأمينك",
        "last-read": "آخر تحقق في {{date}}",
        "quarterly-notice": "لأغراض الفوترة، نحتاج إلى إثبات حالي للتأمين لهذا الربع.",
        "confirm-button": "نعم، هذا هو تأميني",
        "change-button": "لدي تأمين مختلف",
        "contact-title": "طلب إثبات التغطية الإلكترونية",
        "contact-description": "اتصل بشركة التأمين الخاصة بك واطلب إثباتًا إلكترونيًا للتغطية من أجل:",
        "contact-patient": "المريض",
        "contact-kim-address": "عنوان KIM للعيادة",
        "contact-phone": "الهاتف",
        "question": "هل هذا تأمينك الصحي؟",
        "quarterly-notice-v2": "نحتاج مرة كل ربع سنة إلى إثبات من تأمينك الصحي."
      },
      "insurer-search": {
        "title": "اختر التأمين الصحي",
        "subtitle": "يرجى البحث واختيار تأمينك الصحي القانوني.",
        "placeholder": "بحث عن تأمين...",
        "hint": "أدخل حرفين على الأقل للبحث.",
        "no-results": "لم يتم العثور على تأمين.",
        "no-results-hint": "تحقق من الإملاء أو جرب بحثاً مختلفاً.",
        "label": "اسم تأمينك الصحي",
        "search-error-v2": "لم ينجح البحث حاليًا. يرجى المحاولة مرة أخرى.",
        "app-alternative": "تفضل استخدام تطبيق تأمينك الصحي؟"
      },
      "insurer-contact": {
        "title": "طلب إثبات التأمين",
        "subtitle": "الرجاء اختيار أحد الخيارات التالية.",
        "or": "أو",
        "option-eeb-title": "الطلب إلكترونيا",
        "option-eeb-description": "إذا كانت الحالة الاستثنائية القانونية متوفرة، يمكنك بعد موافقتك تسليم الطلب إلى فريق العيادة.",
        "option-qr-title": "المسح باستخدام التطبيق",
        "option-qr-description": "قم بمسح QR code باستخدام تطبيق التأمين الخاص بك.",
        "option-call-title": "اتصل بنفسك",
        "option-call-description": "اتصل بشركة التأمين الخاصة بك واطلب eEB لهذه العيادة:",
        "phone": "الهاتف",
        "phone-not-available": "رقم الهاتف الموجود على بطاقة التأمين الخاصة بك",
        "patient-name": "المريض",
        "practice-kim": "عنوان KIM للعيادة",
        "help-notice": "إذا كان لديك أي مشاكل، يرجى زيارة مكتب الاستقبال.",
        "submit-eeb-button": "اطلب الآن",
        "contacted-button": "لقد اتصلت",
        "contacted-button-countdown": "وقت مكالمتك ({{seconds}}s)",
        "go-to-counter-button": "اذهب إلى الاستقبال",
        "qr-continue-button": "لقد قمت بالمسح الضوئي",
        "qr-continue-button-countdown": "وقت المسح ({{seconds}}s)",
        "title-v2": "إثبات من تأمينك الصحي",
        "subtitle-v2": "الطريقة الأسهل هي تطبيق تأمينك الصحي.",
        "subtitle-no-app": "يرجى اختيار طريقة إرسال الإثبات من تأمينك الصحي إلينا.",
        "option-eeb-description-v2": "نطلب ذلك من تأمينك الصحي نيابةً عنك. نحتاج لذلك إلى موافقتك.",
        "call-instruction": "اتصل بتأمينك الصحي واطلب إرسال الإثبات إلى عيادتنا.",
        "call-instruction-practice": "اتصل بتأمينك الصحي واطلب إرسال الإثبات إلى عيادة {{practice}}.",
        "done-button": "تم – التالي",
        "done-button-countdown": "تم – التالي (متبقٍ {{seconds}} ث)"
      },
      "eeb-consent": {
        "title": "الموافقة",
        "subtitle": "نحتاج إلى موافقتك على التحقق الإلكتروني من التأمين.",
        "insurance": "تأمينك",
        "consent-title": "الموافقة على التحقق الإلكتروني من التأمين (eEB)",
        "consent-text": "أفهم أن شركة التأمين الصحي الخاصة بي ستنقل بيانات التأمين الخاصة بي (مثل الاسم وتاريخ الميلاد ورقم التأمين) عبر خدمة الاتصال الآمنة KIM إلى العيادة {{practiceName}} كدليل على التأمين. أوافق على هذا النقل. أعلم أنه يمكنني سحب هذه الموافقة في أي وقت دون التأثير على علاجي.",
        "withdrawal-notice": "يمكنك سحب هذه الموافقة في أي وقت.",
        "agree-button": "أوافق",
        "decline-button": "إلغاء",
        "treatment-notice": "لن يتأثر علاجك بهذه الموافقة.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "إثبات من تأمينك الصحي",
        "summary": "يرسل تأمينك الصحي الإثبات إلينا مباشرة. نحتاج لذلك إلى موافقتك.",
        "confirm-first": "يرجى تأكيد الإقرار أولًا."
      },
      "qr-code": {
        "title": "امسح بتطبيق شركة التأمين",
        "instruction-1": "افتح تطبيق شركة التأمين الخاصة بك وامسح رمز QR هذا.",
        "instruction-2": "ستتلقى العيادة بعد ذلك تأكيد التأمين الخاص بك تلقائياً.",
        "practice": "العيادة: {{name}}",
        "alternative-hint": "بديل: استخدم تطبيق شركة التأمين",
        "instruction-app": "افتح تطبيق تأمينك الصحي وامسح هذا الرمز. يصلنا الإثبات مباشرة.",
        "staff-line": "لفريق العيادة: {{address}}",
        "staff-line-practice": "لفريق العيادة: {{name}} · {{address}}",
        "alternative-app": "يمكنك أيضًا طلب الإثبات عبر تطبيق تأمينك الصحي: افتح التطبيق وامسح هذا الرمز."
      },
      "register-basics": {
        "title": "المعلومات الشخصية",
        "subtitle": "يرجى إدخال بياناتك.",
        "family-name": "اسم العائلة",
        "given-name": "الاسم الأول",
        "dob": "تاريخ الميلاد",
        "gender": "الجنس",
        "insurance-type": "نوع التأمين",
        "insurer-name": "اسم التأمين الخاص بك",
        "insurer-name-placeholder": "على سبيل المثال ديبيكا، DKV، أليانز...",
        "gender-required": "يرجى اختيار خيار واحد."
      },
      "register-insurer": {
        "title": "التأمين الصحي",
        "subtitle": "يرجى اختيار تأمينك الصحي.",
        "search-placeholder": "بحث عن تأمين..."
      },
      "register-details": {
        "title": "الملخص",
        "subtitle": "يرجى مراجعة معلوماتك.",
        "create": "إكمال التسجيل",
        "missing-data": "يرجى ملء جميع الحقول المطلوبة.",
        "create-error": "فشل التسجيل. يرجى المحاولة مرة أخرى.",
        "policy-number": "رقم السياسة (اختياري)",
        "policy-number-placeholder": "رقم وثيقتك",
        "create-v2": "إنهاء التسجيل",
        "policy-number-hint": "تجد الرقم على بطاقة تأمينك."
      },
      "diff-review": {
        "eyebrow-chip": "مراجعة",
        "eyebrow": "تسجيل الوصول · بيانات البطاقة",
        "title": "مقارنة البيانات",
        "subtitle": "تم العثور على اختلافات بين بيانات بطاقتك وسجلاتنا.",
        "col-current": "السجل الحالي",
        "col-new": "جديد من البطاقة",
        "new-badge": "جديد",
        "field-fallback": "الميدان",
        "note": "تساعدنا البيانات المحدثة على إصدار الفواتير بشكل صحيح والوصول إليك في حالات الطوارئ.",
        "comparison-placeholder": "ستظهر المقارنة هنا",
        "confirm": "تأكيد التغييرات",
        "apply-error": "لا يمكن تطبيق البيانات. يرجى المحاولة مرة أخرى.",
        "retry": "حاول مرة أخرى",
        "skip": "استمر على أي حال",
        "no-changes": "لم يتم العثور على تغييرات",
        "title-v2": "تغيرت بياناتك",
        "subtitle-v2": "على بطاقتك بيانات أحدث. هل نعتمدها؟",
        "confirm-v2": "اعتماد وتسجيل",
        "keep": "التسجيل بدون تغيير",
        "col-current-v2": "السابق",
        "col-new-v2": "الجديد من البطاقة",
        "value-yes": "نعم",
        "value-no": "لا"
      },
      "insurance-selection": {
        "title": "نوع التأمين",
        "subtitle": "يرجى اختيار نوع تأمينك.",
        "gkv": "مؤمن قانونياً",
        "gkv-description": "عضو في تأمين صحي قانوني.",
        "pkv": "خاص أو دفع ذاتي",
        "pkv-description": "مؤمن خاص أو دفع ذاتي.",
        "pkv-description-v2": "تأمين صحي خاص، أو تدفع بنفسك."
      },
      "eeb-request": {
        "title": "تم تسجيل الطلب",
        "subtitle": "يمكنك إتمام تسجيل الوصول. سيصل رد {{insurer}} إلى العيادة لاحقًا.",
        "verifying": "تم قبول طلبك للمعالجة الفورية.",
        "success": "تم تسليم طلبك بأمان إلى فريق العيادة.",
        "error": "تأكيد الطلب غير متاح.",
        "try-alternative": "طريقة بديلة",
        "kim-load-error": "تعذر تحميل عنوان KIM للعيادة.",
        "kim-label": "العيادة · KIM",
        "non-blocking-note": "هذا لا يؤكد بعد استلام شركة التأمين الصحي أو حالة تأمينك.",
        "auto-continue": "المتابعة تلقائيًا خلال {{seconds}} ثانية.",
        "unavailable-title": "للأسف لم ينجح ذلك",
        "unavailable-v2": "تعذر تسجيل طلبك لدى التأمين الصحي.",
        "unavailable-body": "يمكنك طلب الإثبات عبر تطبيق تأمينك الصحي أو تسوية الأمر في الاستقبال.",
        "use-app": "عبر التطبيق",
        "at-reception": "التسوية في الاستقبال"
      },
      "self-pay": {
        "title": "دفع ذاتي",
        "subtitle": "سيتم علاجك كمريض بدفع ذاتي.",
        "info": "يرجى ملاحظة أنك ستكون مسؤولاً عن تكاليف العلاج.",
        "confirm": "مفهوم",
        "title-v2": "تدفع بنفسك",
        "subtitle-v2": "تدفع تكاليف العلاج بنفسك.",
        "insured-after-all": "لدي تأمين بالفعل"
      },
      "done": {
        "title": "تم!",
        "subtitle": "اكتمل تسجيل وصولك.",
        "finish": "إنهاء",
        "done-label": "تم",
        "error-label": "إشعار",
        "eyebrow": "تسجيل الدخول · اكتمل",
        "queue-label": "غرفة الإنتظار",
        "queue-title": "من فضلك إجلس",
        "queue-meta": "سوف نتصل بك شخصيا.",
        "success-title": "تم تسجيل الوصول بنجاح!",
        "success-subtitle": "يرجى الجلوس في غرفة الانتظار. سيتم استدعاؤك.",
        "auto-redirect": "سيتم إعادة توجيهك إلى الصفحة الرئيسية قريباً...",
        "auto-redirect-countdown": "سيتم العودة للبدء خلال ثواني {{seconds}}...",
        "card-expired-title": "البطاقة منتهية الصلاحية",
        "card-expired-subtitle": "انتهت صلاحية بطاقة التأمين الخاصة بك.",
        "card-expired-info": "يرجى الاتصال بالموظفين للحصول على المساعدة.",
        "back-to-start": "العودة إلى البداية",
        "anamnesis-title": "نموذج التاريخ الطبي الكامل",
        "anamnesis-description": "قم بمسح QR code لملء نموذج السجل الطبي الخاص بك بسهولة على هاتفك الذكي.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "تم تسجيلك",
        "card-expired-info-v2": "يرجى التوجه إلى الاستقبال."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "تحقق من بياناتك",
          "balance-prefix": "عند الحفظ:",
          "balance-direct-v2": "يُحفظ فورًا: {{count}}",
          "balance-reception-v2": "يراجعه الاستقبال: {{count}}",
          "chip-reception-v2": "يراجع الاستقبال التغييرات",
          "chip-changed": "تم التغيير: {{count}}",
          "remove": "إزالة",
          "example-email": "مثال: name@example.com",
          "example-phone": "مثال: 0171 1234567",
          "intro-v2": "اكتمل تسجيلك. هل لا تزال هذه البيانات صحيحة؟ التحقق اختياري.",
          "auto-hide": "تُخفى القيم المعروضة مرة أخرى بعد وقت قصير."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "أحلنا هذه المعلومة إلى الاستقبال.",
          "banner-done-v2": "شكرًا! وصلتنا بياناتك.",
          "footer-v2": "تبقى جميع البيانات الأخرى كما هي."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "لأسباب تتعلق بحماية البيانات أغلقنا العرض. ومع ذلك اكتمل تسجيلك. يمكنك إبلاغ الاستقبال بالتغييرات في أي وقت."
        }
      },
      "progress": {
        "identify": "التسجيل",
        "insurance": "التأمين",
        "done": "تم"
      },
      "dob-format-hint": "مثال: 01.10.1980",
      "dob-required": "يرجى إدخال تاريخ ميلادك.",
      "insurance-label": {
        "GKV": "تأمين قانوني",
        "PKV": "تأمين خاص",
        "SELFPAY": "دفع ذاتي"
      }
    },
    "emergency": {
      "title": "حالة طوارئ حادة!",
      "label": "الطوارئ",
      "subtitle": "هذا التنبيه مسموع محليًا فقط ولم يستدعِ المساعدة. في الحالات الطارئة الحادة أو التي قد تهدد الحياة، اتصل بالرقم 112.",
      "call-emergency": "اتصل بخدمات الطوارئ (112)",
      "stop-sound": "توقف عن الصوت",
      "play-sound": "تشغيل الصوت",
      "back-to-start": "العودة للبدء",
      "headline": "يرجى التحدث فورًا مع موظفي الاستقبال. في حالة الخطر على الحياة اتصل بالرقم 112."
    },
    "help-reception": "مساعدة الاستقبال",
    "help-reception-toast": "يرجى الاتصال بالاستقبال. نحن سعداء للمساعدة.",
    "language-entry": {
      "title": "اختر لغتك"
    },
    "loading": "جارٍ التحميل…",
    "step-progress-label": "التقدم",
    "step-progress-phase": "القسم {{current}} من {{total}}: {{phase}}",
    "step-progress-substep": "الجزء {{current}} من {{total}}",
    "step-progress-complete": "مكتمل",
    "identification": {
      "title": "من أنت؟",
      "lead": "الطريقة الأسرع هي بطاقة التأمين الصحي. يمكنك أيضًا البحث باسمك.",
      "lead-card-only": "يرجى إدخال بطاقة التأمين الصحي في قارئ البطاقات.",
      "mode-label": "كيف تريد تسجيل الدخول؟",
      "mode-card": "بالبطاقة",
      "mode-search": "البحث بالاسم",
      "mode-create": "جديد في العيادة",
      "card": {
        "loading": "جارٍ تجهيز قارئ البطاقات …",
        "checking": "جارٍ فحص قارئ البطاقات …",
        "insert-title": "يرجى إدخال بطاقة التأمين الصحي في قارئ البطاقات.",
        "insert-detail": "نقرأ بياناتك تلقائيًا.",
        "detected": "تم التعرف على البطاقة",
        "read": "قراءة البطاقة",
        "reading": "جارٍ قراءة البطاقة …",
        "reading-hint": "يرجى ترك البطاقة في القارئ.",
        "no-terminal-title": "قارئ البطاقات غير متاح",
        "help-with-search": "يرجى البحث باسمك أو السؤال في الاستقبال.",
        "help-reception": "يرجى السؤال في الاستقبال – يسعدنا مساعدتك.",
        "unreadable-title": "تم التعرف على البطاقة لكن لا يمكن قراءتها",
        "error-title": "تعذرت قراءة البطاقة",
        "not-unique": "لم نتمكن من مطابقتك بوضوح مع هذه البطاقة. يرجى البحث باسمك أو السؤال في الاستقبال.",
        "no-match": "لم نجد بيانات مطابقة لهذه البطاقة. يرجى البحث باسمك أو السؤال في الاستقبال.",
        "without-card": "المتابعة بدون بطاقة"
      },
      "lookup": {
        "lead": "يرجى إدخال اسم العائلة وتاريخ الميلاد.",
        "first-name": "الاسم الأول",
        "last-name": "اسم العائلة",
        "dob": "تاريخ الميلاد",
        "dob-hint": "الصيغة: يوم.شهر.سنة",
        "search": "بحث",
        "confirm": "نعم، هذا أنا",
        "found-title": "لقد وجدناك",
        "found-body": "يرجى التأكيد أن الأمر يتعلق بك.",
        "first-name-needed-title": "يرجى إضافة اسمك الأول",
        "first-name-needed-body": "حتى نجدك بوضوح. ثم اضغط على «بحث».",
        "ambiguous-title": "لم نتمكن من إيجادك بوضوح",
        "ambiguous-body": "يرجى السؤال في الاستقبال – يسعدنا مساعدتك.",
        "not-found-title": "لم يتم العثور على بيانات مطابقة",
        "not-found-body": "يرجى التحقق من البيانات المدخلة.",
        "error-title": "البحث غير ممكن حاليًا",
        "error-body": "يرجى المحاولة مرة أخرى أو السؤال في الاستقبال."
      },
      "create": {
        "insurance-question": "ما نوع تأمينك؟",
        "insurance-required": "يرجى اختيار نوع تأمينك.",
        "error-title": "تعذر حفظ بياناتك",
        "error-body": "يرجى المحاولة مرة أخرى أو السؤال في الاستقبال."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "فتح أولا",
      "subtitle": "يجب تنشيط FrontDesk+ في برنامج التدريب الخاص بك.",
      "step1": "اطلب SolStore (أو طلبات شريك Doc-Cirrus لك).",
      "step2": "بعد التنشيط، قم بالتنشيط في inSuite ضمن \"inSuite Sols\" (حقوق المسؤول).",
      "step3": "افتح إدارة Bridge → \"إضافة جهاز\".",
      "cta": "تم كل شيء - المضي قدما"
    },
    "welcome": {
      "title": "أضف هذا الجهاز إلى الممارسة",
      "scan": "التقط صورة للرمز",
      "prepare-link": "لا يوجد رمز في inSuite؟",
      "language": "لغة"
    },
    "scan": {
      "requesting": "الوصول إلى الكاميرا مطلوب...",
      "scanning": "قم بتوجيه الكاميرا نحو الرمز",
      "paste": "لصق بدلا من ذلك",
      "manual-title": "الاتصال يدويا",
      "manual-description": "إذا لم يكن رمز الاستجابة السريعة متاحًا، فاحصل على بيانات الاتصال من إدارة Bridge.",
      "address-label": "عنوان Bridge",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "أدخل SOLTOKEN",
      "manual-submit": "تولي الاتصال",
      "error-title": "لم يتم التعرف على الرمز",
      "camera-denied-title": "تم رفض الوصول إلى الكاميرا",
      "camera-denied-hint": "يُرجى السماح بالوصول إلى الكاميرا في الإعدادات والمحاولة مرة أخرى.",
      "retry": "حاول ثانية"
    },
    "preflight": {
      "title": "سيتم اقامة",
      "all-green": "مرت جميع الاختبارات",
      "practice": "يمارس",
      "device-name": "اسم الجهاز",
      "device-name-placeholder": "على سبيل المثال ب- الاستقبال 1",
      "card-reader": "قارئ البطاقة",
      "pin": "رقم سري جديد",
      "pin-placeholder": "رقم التعريف الشخصي المكون من أربعة أرقام",
      "finish": "ينهي",
      "recheck": "تحقق مرة أخرى",
      "diagnosis": "معرف التشخيص",
      "checklist-error": "رفض Bridge الاتصال أو تعذر الوصول إليه. تحقق من SOLTOKEN وعنوان Bridge.",
      "checklist-retry": "تحقق مرة أخرى",
      "edit-token": "تغيير SOLTOKEN",
      "rescan": "امسح الرمز مرة أخرى"
    },
    "persisting": "جارٍ حفظ الإعداد …",
    "success": {
      "title": "تمت إضافة الجهاز",
      "detail": "لقد ظهر الجهاز للتو على جهاز الكمبيوتر التدريبي.",
      "starting": "يبدأ وضع المريض..."
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "الاتصال ببرنامج التدريب العملي",
        "fix": "Bridge تحقق من الاتصال وعنوان الخادم."
      },
      "missing_insuite_url": {
        "label": "عنوان inSuite",
        "fix": "امسح رمز الاستجابة السريعة ضوئيًا مرة أخرى - العنوان مفقود."
      },
      "missing_server_token": {
        "label": "رمز الخادم",
        "fix": "امسح رمز الاستجابة السريعة ضوئيًا مرة أخرى - الرمز المميز مفقود."
      },
      "missing_gateway_session": {
        "label": "جلسة Gateway",
        "fix": "قم بتسجيل الدخول مرة أخرى - الجلسة مفقودة."
      },
      "missing_gateway_enrollment": {
        "label": "تسجيل الجهاز",
        "fix": "قم بتسجيل الجهاز على Gateway."
      },
      "gateway_not_ready": {
        "label": "استعداد Gateway",
        "fix": "انتظر Gateway لإكمال الإعداد."
      },
      "token_verification_failed": {
        "label": "فحص الرمز المميز",
        "fix": "تحقق من رمز الخادم أو اتصال Bridge."
      },
      "session_expired": {
        "label": "مقابلة",
        "fix": "انتهت صلاحية الجلسة - قم بتسجيل الدخول مرة أخرى."
      },
      "device_revoked": {
        "label": "حالة الجهاز",
        "fix": "لقد تم حظر هذا الجهاز. اتصل بالممارسة."
      },
      "missing_practice_name": {
        "label": "اسم الممارسة",
        "fix": "لا يمكن تحميل اسم الممارسة الطبية (inSuite)."
      },
      "missing_device_name": {
        "label": "اسم الجهاز",
        "fix": "الرجاء إدخال اسم الجهاز."
      },
      "telematik_unavailable": {
        "label": "البنية التحتية لتقنية المعلومات",
        "fix": "اختياري — يظل التحقق من البطاقة ممكنًا بمجرد توفر TI."
      },
      "selected_card_reader_unavailable": {
        "label": "قارئ البطاقة",
        "fix": "اختياري — حدد قارئ بطاقات أو قم بتوصيله."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "اختياري — أدخل بطاقة اعتماد الممارسة الطبية (SMC-B)."
      }
    },
    "token": {
      "title": "أدخل SOLTOKEN",
      "description": "لأسباب أمنية لا يحتوي رمز QR على SOLTOKEN. انسخه في inSuite ضمن «Sol-Aktivierung» (FrontDesk+) والصقه هنا.",
      "submit": "متابعة",
      "rescan": "امسح الرمز مرة أخرى"
    }
  }
}
